import courseIcon from "@/assets/img/menu/course.png";
import studentIcon from "@/assets/img/menu/student.png";
import questionIcon from "@/assets/img/menu/question.png";
import messageIcon from "@/assets/img/menu/message.png";
import systemIcon from "@/assets/img/menu/system.png";
import { getUserRoleKeys } from "@/utils/userInfo";

export const menuConfig = [
  {
    name: "Course",
    path: "/course",
    meta: {
      title: "课程管理",
      icon: courseIcon,
      roles: ["admin", "manager", "teacher"]
    },
    children: [
      {
        path: "index",
        meta: {
          title: "课程中心",
          roles: ["admin", "manager", "teacher"]
        }
      }
    ]
  },
  {
    name: "Question",
    path: "/question",
    meta: {
      title: "题库管理",
      icon: questionIcon,
      roles: ["admin", "manager", "teacher"]
    },
    children: [
      {
        path: "theory",
        meta: {
          title: "理论题库",
          roles: ["admin", "manager", "teacher"]
        }
      },
      {
        path: "practical",
        meta: {
          title: "实操题库",
          roles: ["admin", "manager", "teacher"]
        }
      }
    ]
  },
  {
    name: "Student",
    path: "/student",
    meta: {
      title: "学员管理",
      icon: studentIcon,
      roles: ["admin", "manager", "teacher"]
    },
    children: [
      {
        path: "index",
        meta: {
          title: "学员中心",
          roles: ["admin", "manager", "teacher"]
        }
      }
    ]
  },
  {
    name: "Message",
    path: "/message",
    meta: {
      title: "消息管理",
      icon: messageIcon,
      roles: ["admin", "manager", "teacher"]
    },
    children: [
      {
        path: "index",
        meta: {
          title: "消息中心",
          roles: ["admin", "manager", "teacher"]
        }
      }
    ]
  },
  {
    name: "System",
    path: "/system",
    meta: {
      title: "系统管理",
      icon: systemIcon,
      roles: ["admin", "manager"]
    },
    children: [
      {
        path: "user",
        meta: {
          title: "用户中心",
          roles: ["admin", "manager"]
        }
      },
      {
        path: "role",
        meta: {
          title: "角色中心",
          roles: ["admin", "manager"]
        }
      },
      {
        path: "dict",
        meta: {
          title: "数据字典",
          roles: ["admin"]
        }
      },
      {
        path: "menu",
        meta: {
          title: "菜单管理",
          roles: ["admin"]
        }
      }
    ]
  }
];

function getMenuRoles(menuItem) {
  if (!menuItem) return null;
  return (menuItem.meta && menuItem.meta.roles) || menuItem.roles || null;
}

export function hasMenuRole(menuRoles, roleKeys) {
  const keys = roleKeys || getUserRoleKeys();
  if (!keys || !keys.length) return false;
  if (keys.includes("admin")) return true;
  if (!menuRoles || !menuRoles.length) return true;
  return menuRoles.some(key => keys.includes(key));
}

export function getMenuByRole(roleKeys) {
  const keys = roleKeys || getUserRoleKeys();
  return menuConfig
    .map(item => {
      if (!hasMenuRole(getMenuRoles(item), keys)) return null;
      const children = (item.children || []).filter(child =>
        hasMenuRole(getMenuRoles(child), keys)
      );
      if (!children.length) return null;
      return { ...item, children };
    })
    .filter(Boolean);
}



// WEBPACK FOOTER //
// ./src/router/menu.js